/* A minimal implementation of function composing:
* usage:
* let inc = (a) => a + 1;
* let double = (a) => a * 2;
* let doubleplusplus = compose(
*   inc,
*   double
*  );
*
* doubleplusplus(3) // 7
* */

export default function compose(...fns) {
    return (arg) => {
        return fns.reduceRight((val, fn)=> fn(val), arg);
    };
}


// WEBPACK FOOTER //
// ./src/lib/compose.js